import { motion } from 'framer-motion';

export default function Cookie() {
  return (
    <div className="bg-ivory pt-32 min-h-screen" data-testid="cookie-page">
      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <motion.p
            className="font-body text-xs uppercase tracking-[0.3em] text-champagne mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            Legale
          </motion.p>
          <motion.h1
            className="font-heading text-4xl md:text-5xl text-night tracking-tight mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            data-testid="page-title"
          >
            Cookie Policy
          </motion.h1>
          
          <div className="prose prose-stone max-w-none">
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">1. Cosa Sono i Cookie</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. Ci permettono di riconoscerti e ricordare le tue preferenze nelle visite successive.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">2. Tipi di Cookie Utilizzati</h2>
            
            <h3 className="font-heading text-xl text-night mt-6 mb-3">Cookie Necessari</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Essenziali per il funzionamento del sito. Non possono essere disabilitati. Includono:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Cookie di sessione per il carrello</li>
              <li>Cookie per le preferenze di consenso</li>
              <li>Cookie di sicurezza</li>
            </ul>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">Cookie Analitici</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Ci aiutano a capire come i visitatori interagiscono con il sito. Includono:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Google Analytics (anonimizzati)</li>
              <li>Cookie di performance</li>
            </ul>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">Cookie di Marketing</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Utilizzati per mostrare pubblicità pertinente. Includono:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Facebook Pixel</li>
              <li>Google Ads</li>
              <li>Cookie di retargeting</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">3. Come Gestire i Cookie</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Puoi gestire le tue preferenze sui cookie in diversi modi:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-2 mb-6">
              <li>Attraverso il nostro banner cookie alla prima visita</li>
              <li>Modificando le impostazioni del tuo browser</li>
              <li>Utilizzando strumenti di opt-out dei provider pubblicitari</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">4. Cookie di Terze Parti</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Alcuni cookie sono impostati da servizi di terze parti che appaiono sulle nostre pagine. Non abbiamo controllo su questi cookie. Per maggiori informazioni, consulta le policy dei rispettivi provider.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">5. Aggiornamenti</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Questa Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultarla regolarmente.
            </p>

            <h2 className="font-heading text-2xl text-night mt-8 mb-4">6. Contatti</h2>
            <p className="font-body text-stone-600 leading-relaxed">
              Per domande sui cookie, contattaci a: privacy@lavillapool.it
            </p>
          </div>
        </div>
      </section>

      <div className="h-20 lg:hidden" />
    </div>
  );
}
